module.exports = __webpack_public_path__ + "img/icon-finder.6a2c2e51.svg";